/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { createContext } from 'react';
import noop from '../_util/noop.js';

var MenuContext = /*#__PURE__*/createContext({
  setState: noop,
  onExpand: noop
});

export { MenuContext };
//# sourceMappingURL=MenuContext.js.map
